import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
// import Image from 'next/legacy/image'
import Mask from '../Mask';
import { mergeProps } from '../utils/with-default-props';
import { PropagationEvent } from '../utils/with-stop-propagation';
import { GetContainer } from '../utils/render-to-container';
import { Action, DialogActionButton } from './dialog-action-button';
import styles from './dialog.module.scss';

export interface DialogProps {
  afterClose?: () => void;
  maskStyle?: React.CSSProperties;
  maskClassName?: string;
  bodyStyle?: React.CSSProperties;
  bodyClassName?: string;
  title?: ReactNode;
  content?: ReactNode;
  actions?: (Action | Action[])[];
  onAction?: (action: Action, index: number) => void | Promise<void>;
  closeOnAction?: boolean;
  onClose?: () => void;
  closeOnMaskClick?: boolean;
  visible?: boolean;
  opacity?: 'default' | 'thin' | 'thick' | number;
  showCloseIcon?: boolean;
  addContentStringClassName?: boolean;
  getContainer?: GetContainer;
  stopPropagation?: PropagationEvent[];
}

const defaultProps = {
  actions: [] as Action[],
  closeOnAction: true,
  closeOnMaskClick: false,
  showCloseIcon: false,
  stopPropagation: ['click'],
};

export const Dialog: FC<DialogProps> = (p) => {
  const props = mergeProps(defaultProps, p);

  return (
    <Mask
      visible={props.visible}
      destroyOnClose
      contentAnimated
      isDialog
      getContainer={props.getContainer}
      afterClose={props.afterClose}
      onMaskClick={props.closeOnMaskClick ? props.onClose : undefined}
      style={props.maskStyle}
      opacity={props.opacity}
      className={classNames(styles.dialog_mask, props.maskClassName)}
      stopPropagation={props.stopPropagation}
    >
      <>
        {props.showCloseIcon && (
          <div className={styles.dialog_close}>
            <img
              src='https://i9.taou.com/maimai/p/29913/1247_6_37ha8ZXtQqe0zI'
              alt='close dialog'
              width={8}
              height={8}
              onClick={() => {
                props.onClose?.();
              }}
            />
          </div>
        )}

        <div style={props.bodyStyle} className={classNames(styles.dialog_body, props.bodyClassName)}>
          {!!props.title && <div className={styles.dialog_body_title}>{props.title}</div>}
          {!!props.content && (
            <div className={styles.dialog_body_content}>
              {typeof props.content === 'string' || props.addContentStringClassName ? (
                <div className={styles.dialog_body_content_text}>{props.content}</div>
              ) : (
                props.content
              )}
            </div>
          )}
        </div>
        <div className={styles.dialog_footer}>
          {props.actions.map((row, index) => {
            const actions = Array.isArray(row) ? row : [row];
            return (
              <div
                className={classNames(
                  styles.dialog_action_row,
                  actions.length === 1 && styles.dialog_action_row_center
                )}
                key={index}
              >
                {actions.map((action, index) => (
                  <DialogActionButton
                    key={action.key}
                    action={action}
                    onAction={async () => {
                      await props.onAction?.(action, index);
                      if (props.closeOnAction) {
                        props.onClose?.();
                      }
                    }}
                  />
                ))}
              </div>
            );
          })}
        </div>
      </>
    </Mask>
  );
};
